// import crypto from "crypto";

import  CryptoJS from "crypto-js";


export const encrypt = (obj) => {
    

    var auxObj = obj;

    for (const [key, value] of Object.entries(auxObj)){

        auxObj[key] = CryptoJS.AES.encrypt(value, process.env.SVELTE_API_SECRET).toString();
    }

    // var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(obj), 'secret key 123').toString();

     return auxObj;

}
